<div class="mb-1 pb-1">
  <input pInputText name="jobSearch" [(ngModel)]="jobNumber" placeholder="Job Number" />
  <button pButton type="button" label="Search" (click)="search()"></button>
</div>

<p-table
  #dataTable
  [value]="jobList"
  [lazy]="true"
  selectionMode="single"
  [(selection)]="selectedJob"
  class="custom-class"
  [paginator]="true"
  [loading]="isLoading"
  [rows]="10"
  [totalRecords]="jobCount"
  (onLazyLoad)="onGridLazyLoad($event)"
  [responsive]="true"
  rowHover="true"
  resizableColumns="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Job Number</th>
      <th>Date</th>
      <th>Mode</th>
      <th>Sequence</th>
      <th>Processed</th>
      <th style="width: 90px">Directable</th>
      <th style="width: 90px">Directed</th>
      <th>Alert Matches</th>
      <th>Alerts Sent</th>
      <th>Action</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr (dblclick)="viewHistory(item.id)">
      <td>
        <a href="/app/jobscreen/{{ item.jobId }}">{{ item?.job?.jobNumber }}</a>
      </td>

      <td>{{ item.updated | datex : 'ddd DD MMM HH:mm' }}</td>

      <td style="text-align: center">
        <span *ngIf="item.preview" class="isPreview prl">Preview</span>
        <span *ngIf="!item.preview" class="isLive prl">Live</span>
      </td>

      <td style="text-align: center">
        {{ item?.autoDirectSetting?.sequence }} . {{ item?.autoDirectSetting?.settingName }}
      </td>

      <td style="text-align: center">
        {{ item.processed }}
      </td>

      <td style="text-align: center">{{ item.directable }}</td>

      <td style="text-align: center">{{ item.directedTo }}</td>

      <td style="text-align: center">{{ item.matchedTo }}</td>

      <td style="text-align: center">{{ item.sentTo }}</td>

      <td style="width: 140px; text-align: center">
        <button
          pButton
          (click)="selectedJob = item; viewHistory(item.id)"
          label="Log"
          icon="fa fa-list"
        ></button>
      </td>
    </tr>
  </ng-template>

  <!--

  DATATABLE DEPRECATED

  <p-column header="Job Number" field="autoDirectSummary.job.jobId" [style]="{'text-align':'center'}">>
    <ng-template pTemplate="body" let-item="rowData"><a
        href="/app/jobscreen/{{ item.jobId }}">{{ item.job.jobNumber }}</a></ng-template>
  </p-column>

  <p-column header="Date" field="autoDirectSummary.updated" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">{{ item.updated | datex:'ddd DD MMM HH:mm' }}</ng-template>
  </p-column>

  <p-column header="Mode" field="autoDirectSummary.updated" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <span *ngIf="item.preview" class="isPreview prl">Preview</span>
      <span *ngIf="!item.preview" class="isLive prl">Live</span>
    </ng-template>
  </p-column>

  <p-column header="Sequence" field="autoDirectSummary.autoDirectSetting.settingName">
    <ng-template pTemplate="body" let-item="rowData">{{ item.autoDirectSetting.sequence }}
      . {{ item.autoDirectSetting.settingName }}</ng-template>
  </p-column>


  <p-column header="Processed" field="autoDirectSummary.processed" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">{{ item.processed }}</ng-template>
  </p-column>

  <p-column header="Directable" [style]="{'text-align':'center','width':'90px'}">
    <ng-template pTemplate="body" let-item="rowData">
      {{ item.directable }}
    </ng-template>
  </p-column>

  <p-column header="Directed" [style]="{'text-align':'center','width':'90px'}">
    <ng-template pTemplate="body" let-item="rowData">
      {{ item.directedTo }}
    </ng-template>
  </p-column>

  <p-column header="Alert Matches" field="autoDirectSummary.matched" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">{{ item.matchedTo }}</ng-template>
  </p-column>

  <p-column header="Alerts Sent" field="autoDirectSummary.sent" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">{{ item.sentTo }}</ng-template>
  </p-column>

  <p-column header="Action" field="autoDirectSummary.sent" [style]="{'text-align':'center','width':'140px'}">
    <ng-template pTemplate="body" let-item="rowData">
      <button pButton (click)="selectedJob = item; viewHistory( item.id)" label="Log" icon="fa fa-list"></button>
    </ng-template>
  </p-column>

  -->
</p-table>

<div class="ui-g">
  <div class="ui-g-12">
    <div style="text-align: right; margin-top: 7px">
      <form [formGroup]="runForm">
        <div style="display: inline-block">
          <label for="jobNumber">Run AutoDirect: </label>
          <input
            id="jobNumber"
            pInputText
            formControlName="jobNumber"
            placeholder="Job Number"
            style="padding-bottom: 5px; margin-right: 10px"
          />
        </div>
        <p-dropdown
          [style]="{ width: '200px' }"
          [options]="autoDirectSettingList"
          formControlName="autoDirectSettingsId"
        ></p-dropdown>

        Preview Mode:
        <p-inputSwitch formControlName="preview"></p-inputSwitch>
        <button
          class="ml-2"
          pButton
          (click)="runAutoDirect()"
          [disabled]="!previewForm.jobNumber"
          [label]="running ? 'Please Wait...' : 'Run AutoDirect'"
        ></button>
      </form>
      <div *ngIf="errorMsg" class="mt-2">
        <div class="text-danger">Error: {{ errorMsg }}</div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="AutoDirect Log for {{ selectedJob?.job?.jobNumber }}"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [positionTop]="10"
  [style]="{ width: '1000px' }"
>
  <div class="ui-widget-header" style="padding: 4px 10px; border-bottom: 0 none">
    <i class="fa fa-search" style="margin: 4px 4px 0 0"></i>
    <input
      #gb
      type="text"
      [(ngModel)]="globalFilter"
      pInputText
      size="50"
      placeholder="Global Filter"
    />
  </div>

  <p-table
    #dataTable2
    [value]="logList"
    [rows]="10"
    [lazy]="false"
    selectionMode="single"
    [globalFilter]="gb"
    [(selection)]="selectedLog"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="rank">Rank</th>
        <th pSortableColumn="supplierName">Supplier</th>
        <th pSortableColumn="matchedToJobNumber">JobID</th>
        <th pSortableColumn="matchedToJobId">Comment</th>
        <th pSortableColumn="distance">Distance</th>
        <th pSortableColumn="matchedTo">AlertID</th>
        <th pSortableColumn="directable">Directable</th>
        <th pSortableColumn="directSent">Directed</th>
        <th pSortableColumn="matched">Alert Match</th>
        <th pSortableColumn="sent">Alerted</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="text-align: center">
          <span [pTooltip]="item?.id">{{ item?.rank }}</span>
        </td>
        <td>{{ item.supplierName }}</td>
        <td>
          <a href="/app/jobscreen/{{ item?.matchedToJobId }}">{{ item?.matchedToJobNumber }}</a>
        </td>
        <td>
          <div *ngIf="item?.matchedToJobNumber">
            <a
              href="/app/jobscreen/{{ item?.matchedToJobId }}"
              pTooltip="{{ item?.matchStatusDesc }}"
              >{{ item?.matchStatusDesc }}</a
            >
          </div>
          <div *ngIf="!item?.matchedToJobNumber">
            <span pTooltip="{{ item?.matchStatusDesc }}">{{ item?.matchStatusDesc }}</span>
          </div>
        </td>
        <td style="text-align: center">
          <span *ngIf="item?.distance >= 999">-</span>
          <span *ngIf="item?.distance < 999"
            >{{ item.distance }} <span class="miles">miles</span></span
          >
        </td>
        <td>{{ item?.matchedTo }}</td>
        <td style="text-align: center">
          <span *ngIf="item?.directable"><i class="fa fa-check"></i></span>
          <span *ngIf="!item?.directable"><i class="fa fa-times"></i></span>
        </td>
        <td style="text-align: center">
          <span *ngIf="item?.directedSent"><i class="fa fa-check"></i></span>
          <span *ngIf="!item?.directedSent"><i class="fa fa-times"></i></span>
        </td>
        <td style="text-align: center">
          <span *ngIf="item?.matched === 1"
            ><span tooltipStyleClass="xtooltip" pTooltip="Matches JobAlert settings"
              ><i class="fa fa-check"></i></span
          ></span>
          <span *ngIf="item?.matched === 0"
            ><span tooltipStyleClass="xtooltip" pTooltip="Matches AutoDirect settings"></span
            ><i class="fa fa-minus"></i
          ></span>
          <span *ngIf="item?.matched <= -1"
            ><span tooltipStyleClass="xtooltip" pTooltip="Does not match JobAlert settings"
              ><i class="fa fa-times"></i></span
          ></span>
        </td>
        <td style="text-align: center">
          <span *ngIf="item.sent"><i class="fa fa-check"></i></span>
          <span *ngIf="!item.sent"><i class="fa fa-times"></i></span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DATATABLE DEPRECATED --

  <p-dataTabl #dataTable2 [value]="logList" [rows]=10 [lazy]="false"
               selectionMode="single"
               [globalFilter]="gb"
               [(selection)]="selectedLog"
               [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true">


    <p-column field="rank" header="Rank" [sortable]="tru" [style]="{'text-align':'center','width':'60px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span [pTooltip]="item?.id">{{ item?.rank }}</span>
      </ng-template>
    </p-column>

    <p-column [sortable]="tru" field="supplierName" header="Supplier" filterMatchMode="contains"></p-column>

    <p-column [sortable]="tru" field="item?.matchedToJobNumber" header="JobID" [style]="{'text-align':'center'}">
      <ng-template pTemplate="body" let-item="rowData" pTooltip="Matched to Job ID"><a
          href="/app/jobscreen/{{ item?.matchedToJobId }}">{{ item?.matchedToJobNumber }}</a></ng-template>
    </p-column>

    <p-column [sortable]="tru" field="matchStatusDesc" header="Comment" [style]="{'text-align':'center'}"
              filterMatchMode="contains">
      <ng-template pTemplate="body" let-item="rowData">
        <div *ngIf="item?.matchedToJobNumber"><a href="/app/jobscreen/{{ item?.matchedToJobId }}"
                                                 pTooltip="{{ item?.matchStatusDesc }}">{{ item?.matchStatusDesc }}</a>
        </div>
        <div *ngIf="!item?.matchedToJobNumber">
          <span pTooltip="{{ item?.matchStatusDesc }}">{{ item?.matchStatusDesc }}</span>
        </div>
      </ng-template>
    </p-column>

    <p-column [sortable]="tru" header="Distance" field="distance" [style]="{'text-align':'center', 'width':'100px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span *ngIf="item?.distance >= 999">-</span>
        <span *ngIf="item?.distance < 999">{{ item.distance }} <span class="miles">miles</span></span>
      </ng-template>
    </p-column>

    <p-column [sortable]="tru" header="AlertID" field="matchedTo" [style]="{'text-align':'center','width':'90px'}">
      <ng-template pTemplate="body" let-item="rowData"
                   pTooltip="Matched to Alert ID">{{ item?.matchedTo }}</ng-template>
    </p-column>

    <p-column [sortable]="tru" header="Directable" field="directable" [style]="{'text-align':'center','width':'90px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span *ngIf="item?.directable"><i class="fa fa-check"></i></span>
        <span *ngIf="!item?.directable"><i class="fa fa-times"></i></span>
      </ng-template>

    </p-column>

    <p-column [sortable]="tru" header="Directed" field="directedSent" [style]="{'text-align':'center','width':'90px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span *ngIf="item?.directedSent"><i class="fa fa-check"></i></span>
        <span *ngIf="!item?.directedSent"><i class="fa fa-times"></i></span>
      </ng-template>
    </p-column>

    <p-column [sortable]="tru" header="Alert Match" field="matched" [style]="{'text-align':'center','width':'70px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span *ngIf="item?.matched === 1"><span tooltipStyleClass="xtooltip" pTooltip="Matches JobAlert settings"><i
            class="fa fa-check"></i></span></span>
        <span *ngIf="item?.matched === 0"><span tooltipStyleClass="xtooltip"
                                                pTooltip="Matches AutoDirect settings"></span><i
            class="fa fa-minus"></i></span>
        <span *ngIf="item?.matched <= -1"><span tooltipStyleClass="xtooltip"
                                                pTooltip="Does not match JobAlert settings"><i class="fa fa-times"></i></span></span>
      </ng-template>
    </p-column>

    <p-column [sortable]="tru" header="Alerted" field="sent" [style]="{'text-align':'center','width':'70px'}">
      <ng-template pTemplate="body" let-item="rowData">
        <span *ngIf="item.sent"><i class="fa fa-check"></i></span>
        <span *ngIf="!item.sent"><i class="fa fa-times"></i></span>
      </ng-template>
    </p-column>

  </p-dataTable>

  --->
</p-dialog>

<ng-template #loading>Loading...</ng-template>
